import React, { useEffect } from 'react';
import { useProductCondition } from 'src/hooks/experiments';
import { Category, Maybe } from 'src/types';

const ProductConditionSplitExperiment: React.FC<IProductConditionSplitExperimentProps> = props => {
  const isMobilePhoneCategory = props?.category?.id === '103';
  const isGamesCategory = props?.category?.path?.some(
    path => path?.id === '378'
  );

  return isMobilePhoneCategory || isGamesCategory ? (
    <Experiment setUseProductCondition={props.setUseProductCondition} />
  ) : null;
};

const Experiment: React.FC<IExperimentProps> = props => {
  const productConditionExperiment = useProductCondition();
  const { setUseProductCondition } = props;

  useEffect(() => {
    setUseProductCondition(productConditionExperiment);
  }, [productConditionExperiment, setUseProductCondition]);

  return <></>;
};

interface IProductConditionSplitExperimentProps {
  setUseProductCondition: React.Dispatch<React.SetStateAction<boolean>>;
  category: Maybe<Category>;
}

interface IExperimentProps {
  setUseProductCondition: React.Dispatch<React.SetStateAction<boolean>>;
}

export default ProductConditionSplitExperiment;
